import { put, call, takeLatest } from 'redux-saga/effects'
import {
  REQUEST_INTEGRAL_DATA
} from '../constants/integralConstant'
import {
  setIntegralData
} from '../actions/integralAction'
import { setLoadingState, setErrorMessage } from '../actions/commonAction'

function * requestIntegralSaga () {
  yield put(setLoadingState({ loading: true }))
  let request = () => {
    const pointsConfig = {
      method: 'get',
      url: window.API.Integral.getPoints
    }
    const listConfig = {
      method: 'get',
      url: window.API.Integral.getIntegralList
    }
    return Promise.all([
      window.axios.request(pointsConfig),
      window.axios.request(listConfig)
    ])
  }
  try {
    let data = yield call(request)
    yield put(setLoadingState({ loading: false }))
    yield put(setIntegralData(data))
  } catch (error) {
    yield put(setErrorMessage(error.message))
  }
}

export function integralSaga () {
  return takeLatest(REQUEST_INTEGRAL_DATA, requestIntegralSaga)
}
